import {Pipe} from '@angular/core';
import {DatePipe} from '@angular/common';
import moment from 'moment-timezone';
import {environment} from '../../../environments/environment';

const timestampRegex = RegExp('^\\d\\d\\d\\d-(\\d)?\\d-(\\d)?\\d \\d\\d:\\d\\d:\\d\\d$');

@Pipe({
  name: 'utcToLocal'
})
/** @deprecated Prefer `toLocalFromApi` from `shared/datetime/datetime-boundary` in services (AC-40). */
export class UtcToLocalPipe extends DatePipe {

  override transform(value: string, format?: string): any {

    if (timestampRegex.test(value)) {

      const utcOffset = moment().utcOffset();
      const dateToDisplay = moment(value).add(utcOffset, 'minutes');
      return dateToDisplay.format(format || environment.dateTimeFormat);
    }
    return value;
  }
}
